import { ROLE } from '@/constants/role'

export const getRoleByUid = (uid: string) => {
  if (!uid) return null
  if (/^TE_/.test(uid)) return ROLE.HOST
  if (/^AU_/.test(uid)) return ROLE.AUDIENCE
  return null
}
